import { createChoices } from '../../../core/component/choices/choices.js';

// Platzierungs Types Mutual Exclusion Component
export default () => ({
    selects: [],
    choicesInstances: new Map(),
    init() {
        this.selects = Array.from(this.$el.querySelectorAll('.platzierungs-select'));

        if (this.selects.length === 0) {
            return;
        }

        this.initChoices();
        this.filterOptions();

        this.selects.forEach(select => {
            select.addEventListener('change', () => this.filterOptions());
        });
    },
    initChoices() {
        this.selects.forEach(select => {
            const choices = createChoices(select);
            this.choicesInstances.set(select, choices);
        });
    },
    destroyChoices() {
        this.choicesInstances?.forEach(choices => choices?.destroy());
        this.choicesInstances?.clear();
    },
    filterOptions() {
        const selectedValuesBySelect = new Map();
        this.selects.forEach(select => {
            const values = Array.from(select.selectedOptions).map(o => o.value);
            selectedValuesBySelect.set(select, values);
        });

        this.selects.forEach(currentSelect => {
            const otherSelectedValues = [];
            this.selects.forEach(otherSelect => {
                if (otherSelect !== currentSelect) {
                    otherSelectedValues.push(...selectedValuesBySelect.get(otherSelect));
                }
            });

            Array.from(currentSelect.options).forEach(option => {
                const alreadySelectedElsewhere = otherSelectedValues.includes(option.value);
                option.disabled = alreadySelectedElsewhere;
                option.hidden = alreadySelectedElsewhere;
            });
        });

        this.destroyChoices();
        this.initChoices();
    },
    destroy() {
        this.destroyChoices();
    }
});
